(function($){

	var homeHeroSlider = function() {
		$('.hero-slider').slick({
			arrows: false,
			// prevArrow: '<button class="slick-prev slick-arrow" aria-label="Previous" type="button"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20.93 70"><polygon points="20.77 70 8.15 35.01 20.93 0 13.02 0 0 35 13.02 70 20.77 70"/></svg></button>',
			// nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20.93 70"><polygon points=".16 0 12.78 34.99 0 70 7.91 70 20.93 35 7.91 0 .16 0"/></svg></button>',
			dots: false,
			fade: true,
			speed: 2000,
			autoplay: true,
			autoplaySpeed: 4000,
			pauseOnHover: false
		});
	};

	var heroVideo = function() {

		$('[data-action="hero-popup-play"]').on('click', function(e) {
			e.preventDefault();

			var heroVideoModal = document.getElementById('hero-video-modal');
			var heroVideoModalObj = $('#hero-video-modal');

			$.magnificPopup.open({
				mainClass: 'hero-popup',
				items: {
					src: '#hero-video-modal-container',
					type: 'inline',
				},
				callbacks: {
					open: function() {
						if(heroVideoModalObj.length){
							heroVideoModal.play();
						}
					},
					close: function() {
						if(heroVideoModalObj.length){
							heroVideoModal.pause();
							heroVideoModal.currentTime = 0;
						}
					},
				}
			}, 0);
			
		});
		
		$('[data-action="hero-popup-embed"]').magnificPopup({
			type: 'iframe',
			// mainClass: 'hero-popup'
		});

	};


	var scrollAnim = function(){

		///** convert to use intersectionObserver **///

		var win = $(window);

		var items = $('.scroll-animate-item');

		var itemScrollCheck = function(){

			var winHeight = win.innerHeight();
			var winTop = win.scrollTop();
			var scrollTriggerPos = (winHeight * .8) + winTop;

			items.each(function(i, el){

				var item = $(el);
				var itemTop = item.offset().top;

				if(itemTop <= scrollTriggerPos){
					item.addClass('vis');
				}
				else{
					item.removeClass('vis');
				}

			});

		};

		itemScrollCheck();
		optimizedScroll.add(itemScrollCheck);
	};


	var scrollToAnchor = function(){

		if( location.hash ){
			// window.scrollTo(0,0);

			$( 'body' ).removeClass( 'nav-open' );
			
			var locationHashObj = $(location.hash);
			
			if(locationHashObj.length > 0){
				//$('body').removeClass('nav-open');
				// $('body,html').animate({
				// 	scrollTop: locationHashObj.offset().top - 150
				// }, 500);

				var waitTime = 501;

				if(!$('body').hasClass('scrolled')){
					waitTime = 501;
					$('body').addClass('scrolled');
				}

				setTimeout(function(){
					var anchorPosition = locationHashObj.offset().top;
					var finalPosition = anchorPosition - $('.site-header').outerHeight() - 20;
					$("html, body").animate({scrollTop: finalPosition}, 1000);


				}, waitTime);
			}
		}

		$('.scroll-to-anchor a, a[href^="#"]').on('click', function(e){
			
			if($(this).hasClass('no-scroll')){
				return;
			}
			else if(this.hash){
				
				var hashTarget = $(this.hash);

				if( hashTarget.length ){
					e.preventDefault();
					var waitTime = 0;
					
					if(!$('body').hasClass('scrolled')){
						waitTime = 501;
						$('body').addClass('scrolled');
					}

					setTimeout(function(){
						var anchorPosition = hashTarget.offset().top;
						var finalPosition = anchorPosition - $('.site-header').outerHeight() - 20;
						$("html, body").animate({scrollTop: finalPosition}, 1000);

						$( 'body' ).removeClass( 'nav-open' );

					}, waitTime);
				}
			}
		});
	};

	var blockGallery = function() {
		$('.wp-block-gallery').magnificPopup({
			delegate: 'a',
			type: 'image',
			gallery: {
				enabled: true
			}
		})
	};

	var homeTabs = function() {

		// $('.tab-slider').on('init', function(event, slick){
		// 	console.log('init');
			// $('.tab-2').removeClass('active');
		// });
		
		$('.tab-1 .tab-slider').slick({
			arrows: true,
			prevArrow: '<button class="slick-prev slick-arrow" aria-label="Previous" type="button"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28.6 50"><polygon points="28.6 50 11.4 25 28.6 0 17.2 0 0 25 17.2 50 28.6 50"/></svg></button>',
			nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28.6 50"><polygon points="0 0 17.2 25 0 50 11.4 50 28.6 25 11.4 0 0 0"/></svg></button>',
			dots: false,
			speed: 2000,
			// autoplay: true,
			autoplaySpeed: 4000,
			pauseOnHover: false
		});

		$('[data-action="tab"]').on('click', function(e) {
			// e.preventDefault();
			// $('.tabs-container').
			var thisTab = $(this).parents('.tab');
			$('.tab').not(thisTab).removeClass('active');
			thisTab.addClass('active');

			$('.tab').not(thisTab).find('.tab-slider').slick('unslick');

			thisTab.find('.tab-slider').slick({
				arrows: true,
				prevArrow: '<button class="slick-prev slick-arrow" aria-label="Previous" type="button"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28.6 50"><polygon points="28.6 50 11.4 25 28.6 0 17.2 0 0 25 17.2 50 28.6 50"/></svg></button>',
				nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28.6 50"><polygon points="0 0 17.2 25 0 50 11.4 50 28.6 25 11.4 0 0 0"/></svg></button>',
				dots: false,
				speed: 2000,
				// autoplay: true,
				autoplaySpeed: 4000,
				pauseOnHover: false
			});

			// $('.tab-slider').slick();
		});

	};

	var megaMenu = function() {
		var officeInfoContainer = $('.box.office');
		var phone = officeInfoContainer.find('.phone');
		var email = officeInfoContainer.find('.email');
		var address = officeInfoContainer.find('.address');
		var hours = officeInfoContainer.find('.hours');
		var officeInfoHtml = '';

		if(phone.length){
			officeInfoHtml += phone[0].outerHTML;
		}
		if(email.length){
			officeInfoHtml += email[0].outerHTML;
		}
		if(address.length){
			officeInfoHtml += address[0].outerHTML;
		}
		if(hours.length){
			officeInfoHtml += hours[0].outerHTML;
		}

		$('.menu-item-has-children.megamenu').find('.mega-menu-contact-info').each(function(i,el) {
			$(this).html(officeInfoHtml);
		});

		// var extraHtml = '<div class="megamenu-extra-content"><div class="label">Resource center quick jump:</div><a href="" class="button red">Calculators</a></div>';
		// $('.menu-item-has-children.megamenu').find('.extra').html(extraHtml);
	};

	var searchToggle = function(){
		
		$('#header-search').on('click', function(e){
			e.stopPropagation();
		});

		$('#header-search-toggle').on('click', function(e){
			$('#header-search').toggleClass('active');
			document.getElementById("header-search-input").focus();
		});

		$('#header-search-close').on('click', function(e){
			$('#header-search').removeClass('active');
			document.getElementById("header-search-input").blur();
		});

		$(document).on('click.closesearch', function(e) {
			$('#header-search').removeClass('active');
			document.getElementById("header-search-input").blur();
		})
	};


	var caseGallery = function() {
		$('.msw-case-gallery').slick({
			arrows: true,
			prevArrow: '<button class="slick-prev slick-arrow" aria-label="Previous" type="button"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28.6 50"><polygon points="28.6 50 11.4 25 28.6 0 17.2 0 0 25 17.2 50 28.6 50"/></svg></button>',
			nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28.6 50"><polygon points="0 0 17.2 25 0 50 11.4 50 28.6 25 11.4 0 0 0"/></svg></button>',
			dots: true,
			speed: 1000,
			autoplay: true,
			autoplaySpeed: 3000,
			pauseOnHover: false
		});
	};

	var serviceContentSlider = function() {
		$('.service-content-slider').slick({
			arrows: true,
			prevArrow: '<button class="slick-prev slick-arrow" aria-label="Previous" type="button"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28.6 50"><polygon points="28.6 50 11.4 25 28.6 0 17.2 0 0 25 17.2 50 28.6 50"/></svg></button>',
			nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28.6 50"><polygon points="0 0 17.2 25 0 50 11.4 50 28.6 25 11.4 0 0 0"/></svg></button>',
			dots: false,
			speed: 1000,
			// autoplay: true,
			// autoplaySpeed: 4000,
			pauseOnHover: false,
			slidesToShow: 3,
			slidesToScroll: 3,
			responsive: [
				{
					breakpoint: 767,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 2,
					}
				},
				{
					breakpoint: 600,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1
					}
				}
			]
		});
	};

	var careersSlider = function() {
		$('.careers-slider').slick({
			arrows: true,
			prevArrow: '<button class="slick-prev slick-arrow" aria-label="Previous" type="button"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28.6 50"><polygon points="28.6 50 11.4 25 28.6 0 17.2 0 0 25 17.2 50 28.6 50"/></svg></button>',
			nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28.6 50"><polygon points="0 0 17.2 25 0 50 11.4 50 28.6 25 11.4 0 0 0"/></svg></button>',
			dots: false,
			speed: 1000,
			// autoplay: true,
			// autoplaySpeed: 4000,
			pauseOnHover: false,
			slidesToShow: 4,
			slidesToScroll: 4,
			responsive: [
				{
					breakpoint: 1024,
					settings: {
						slidesToShow: 3,
						slidesToScroll: 3,
					}
				},
				{
					breakpoint: 767,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 2,
					}
				},
				{
					breakpoint: 600,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1
					}
				}
			]
		});
	};

	var careersTabs = function() {

		$('a[href^="#careers-tab-"]').on('click', function(e){
			e.preventDefault();
			var target = this.hash;
			$('.careers-tabs').find('.tab').not(target).removeClass('current');
			$(target).addClass('current');
			
			// console.log(target);

			var tabNavId = $(target).attr('data-nav');
			// console.log(tabNavId);
			$('.tabs-nav').find('li').not('#'+tabNavId).removeClass('current');
			$('#'+tabNavId).addClass('current');
		});

		$('[data-action="tab-item"]').magnificPopup({
 			 type:'inline',
 			 mainClass: 'tab-item-popup'
		});


		if( location.hash ){
			// window.scrollTo(0,0);

			$( 'body' ).removeClass( 'nav-open' );


			var hashTabLink = $('.tabs-nav').find('a[href="'+location.hash+'"]');

			if(hashTabLink.length){

				hashTabLink.trigger('click');
				//console.log(hashTabLink);
				window.scrollTo(0, 1);
				// window.scrollTo(0, $('.careers-tabs').offset().top - $('.site-header').outerHeight() - 20);
			

				// var waitTime = 501;

				// if(!$('body').hasClass('scrolled')){
				// 	waitTime = 501;
				// 	$('body').addClass('scrolled');
				// }

				setTimeout(function(){
					var anchorPosition = $('.careers-tabs').offset().top;
					var finalPosition = anchorPosition - $('.site-header').outerHeight() - 20;
					$("html, body").animate({scrollTop: finalPosition}, 500);

				}, 500);


			}
		}
	};

	var calculators = function() {
		var calcForm = $('.calc-form');
		var calcFormId = calcForm.attr('id');
		var calcFormInput = calcForm.find('input');
		var thisInputFactor = 0;
		var thisInputNumber = 0;
		var baseNumber = 0;
		var precision = parseInt(calcForm.data('precision'));
		var initval = '';

		calcFormInput.on('focus', function(e) {
			initval = $(this).val();
			// console.log(this.value);
		});

		if(calcFormId == 'calc_temperature'){
			// C = (°F - 32) ÷ 1.8 

			var temp_c = 0;
			var temp_f = 0;
		
			calcFormInput.on('change blur', function(e) {
				var thisInput = $(this);
				
				if(thisInput.val() && thisInput.val() !== initval){
					initval = thisInput.val();
					calcFormInput.not(this).val('');
					thisInputNumber = thisInput.val();

					if(thisInput.attr('name') == 'f'){
						temp_f = thisInput.val();
						temp_c = (temp_f - 32) / 1.8;
						calcForm.find('input[name="c"]').val(parseFloat(temp_c.toFixed(precision)));
					}
					else if(thisInput.attr('name') == 'c'){
						temp_c = thisInput.val();
						temp_f = (temp_c * 1.8) + 32;
						calcForm.find('input[name="f"]').val(parseFloat(temp_f.toFixed(precision)));
					}
				}
			});
		}
		else{
		
			calcFormInput.on('change blur', function(e) {
				
				var thisInput = $(this);

				if(thisInput.val() && thisInput.val() !== initval){
					initval = thisInput.val();
					calcFormInput.not(this).val('');
					thisInputFactor = thisInput.data('factor');
					thisInputNumber = thisInput.val();

					var baseNumber = thisInputNumber * thisInputFactor;

					calcFormInput.each(function(i,el) {
						var elFactor = $(el).data('factor');
						var elVal = baseNumber / elFactor;

						$(el).val(parseFloat(elVal.toFixed(precision)));
					});
					
					// calcForm.submit();
				}
				
			});
		}

		calcForm.on('submit', function(e) {
			e.preventDefault();
			// formData = $(this).serialize();
		});

		$('.calc-form-clear').on('click', function(e) {
			calcFormInput.val('');
		});
	};


	Number.prototype.countDecimals = function () {

		if (Math.floor(this.valueOf()) === this.valueOf()){
			return 0;
		}

		var str = this.toString();
		if (str.indexOf(".") !== -1 && str.indexOf("-") !== -1) {
			return str.split("-")[1] || 0;
		}
		else if (str.indexOf(".") !== -1) {
			return str.split(".")[1].length || 0;
		}

		return str.split("-")[1] || 0;
	}

	var animateNumbers = function(){
		
		var win = $(window);

		function animateValue(obj, start, end, duration) {

			if($(obj).attr('data-anim') == 'true'){
				$(obj).attr('data-anim', 'false');

				var endDecimals = end.countDecimals();
				// console.log(endDecimals);

				let startTimestamp = null;
				const step = (timestamp) => {
					if (!startTimestamp){
						startTimestamp = timestamp;
					}
					const progress = Math.min((timestamp - startTimestamp) / duration, 1);
					// obj.innerHTML = Math.floor(progress * (end - start) + start);
					var numDecimals = progress * (end - start) + start;
					// var numFinal;
					
					if(end % 1 != 0){
						// obj.innerHTML = numDecimals.toFixed(endDecimals).toLocaleString();
						obj.innerHTML = numDecimals.toLocaleString(undefined, {minimumFractionDigits: endDecimals, maximumFractionDigits: endDecimals});
					}
					else{
						obj.innerHTML = Math.floor(numDecimals).toLocaleString();
					}
					if (progress < 1) {
						window.requestAnimationFrame(step);
					}
					else{
						// obj.innerHTML = 0;
						// $(obj).attr('data-anim', 'true');
						// console.log('done');
					}
				};
				window.requestAnimationFrame(step);
			}
		}

		$('.number-container').each(function(i,el){
			var elObj = $(el);
			var thisNum = elObj.attr('data-number');
			var thisPrepend = elObj.attr('data-prepend');
			var thisAppend = elObj.attr('data-append');
			var thisNumAnim = elObj.find('.number-anim');
			elObj.prepend('<span class="number-placeholder">' + '<span class="prepend">' + thisPrepend + '</span>' + thisNum + '<span class="append">' + thisAppend + '</span></span>');
			thisNumAnim.attr('data-anim', 'true');
			thisNumAnim.html(0);
		});

		var numbersAnim = function(){
			var winHeight = win.innerHeight();
			var winTop = win.scrollTop();
			var scrollTriggerPos = (winHeight * .8) + winTop;

			$('.number-anim').each(function(i,el){

				// var num = parseFloat($(el).attr('data-number'));

				// animateValue(el, 0, num, 2000);
				
				var numObj = $(el);
				var objTop = numObj.offset().top;
				var num = parseFloat($(el).attr('data-number'));
				// // var doAnim = true;

				// // $(el).html(0);
				// // if(isDone != true){
					if(objTop <= scrollTriggerPos){
						// console.log('scrn');
						animateValue(el, 0, num, 2000);
						$(el).attr('data-anim', 'false');
					}
					// else if(objTop >= (winTop + winHeight)){
					// 	// console.log('scrn');
						// animateValue(el, num, 0, 100);
					// }
					else{
						// animateValue(el, num, 0, 100);
						// $(el).removeClass('anim');
						// doAnim = true;
						// $(el).html(0);
						// $(el).attr('data-anim', 'true');
					}

					if(objTop > ( winHeight + winTop )){
						// console.log('offscrn');
						animateValue(el, num, 0, 100);
						// $(el).removeClass('anim');
						// doAnim = true;
						$(el).html(0);
						$(el).attr('data-anim', 'true');
					}
				
			});
		};

		// numbersAnim();
		optimizedScroll.add(numbersAnim);
	};


	var gallerySlider = function() {
		$('.gallery-slider').slick({
			arrows: true,
			prevArrow: '<button class="slick-prev slick-arrow" aria-label="Previous" type="button"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28.6 50"><polygon points="28.6 50 11.4 25 28.6 0 17.2 0 0 25 17.2 50 28.6 50"/></svg></button>',
			nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28.6 50"><polygon points="0 0 17.2 25 0 50 11.4 50 28.6 25 11.4 0 0 0"/></svg></button>',
			dots: true,
			speed: 1000,
			autoplay: true,
			autoplaySpeed: 3000,
			pauseOnHover: false
		});
	};

	$(document).ready(function(){
		homeHeroSlider();
		heroVideo();
		scrollAnim();
		scrollToAnchor();
		blockGallery();
		homeTabs();
		megaMenu();
		searchToggle();
		caseGallery();
		serviceContentSlider();
		careersSlider();
		careersTabs();
		calculators();
		animateNumbers();
		gallerySlider();
	});

    window.addEventListener('load', function() {
        var videoContainer = $('.hero-video-container');
        videoContainer.addClass('vis');
    }, false);

})(jQuery);

/* Lazy load bg images https://web.dev/lazy-loading-images/ */
// document.addEventListener("DOMContentLoaded", function() {
//   var lazyBackgrounds = [].slice.call(document.querySelectorAll(".lazy-background"));

//   if ("IntersectionObserver" in window) {
//     let lazyBackgroundObserver = new IntersectionObserver(function(entries, observer) {
//       entries.forEach(function(entry) {
//         if (entry.isIntersecting) {
//           entry.target.classList.add("visible");
//           lazyBackgroundObserver.unobserve(entry.target);
//         }
//       });
//     });

//     lazyBackgrounds.forEach(function(lazyBackground) {
//       lazyBackgroundObserver.observe(lazyBackground);
//     });
//   }
// });